import { Navigate, useNavigate, useParams } from "react-router-dom";
import { routePaths } from "./routePaths";
import {
  setMenuTitle,
  setShowMenu,
  setShowSubMenu,
} from "../redux/slices/common_slice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const ProtectedRoute = ({ children }) => {
  const menuTitle = useSelector((state) => state.common?.menuTitle);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const params = useParams();
  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      if (window.innerWidth < 768) {
        dispatch(setShowSubMenu(true));
        dispatch(setShowMenu(true));
        if (params?.["*"]) {
          if (
            menuTitle === t("commonStepper.section1") ||
            menuTitle === t("commonStepper.section2") ||
            menuTitle === t("commonStepper.section3")
          ) {
            navigate("/settings/edit-form");
            dispatch(setMenuTitle(t("settings.editForm")));
          } else {
            navigate("/settings");
            dispatch(setMenuTitle(t("settings.title")));
          }
        }
      }
      // Optionally, handle what to do when back is pressed
      // For example, you might want to redirect or show a message
    };
    window.addEventListener("popstate", handlePopState);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [menuTitle]);
  const accessToken = localStorage.getItem("token");
  if (accessToken) {
    return children;
  }
  return <Navigate to={routePaths.login} />;
};

export default ProtectedRoute;
